/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa loan calculator
 *
 */
Intesa.LoanCalculatorAlbania = function() {

	/**
	 * Local variables
	 *
	 */
	var loan = this;
	var resetString = "-";
	var validPromoResults = true;
	var validStandardResults = true;
	var genericSettings = JSON.parse( $( "#genericSettings" ).val() );
	var regExSeparator = "\\" + genericSettings.separator;
	if( regExSeparator == "\\&nbsp;" ) regExSeparator = "\\ ";
	var regExDecimal = "\\" + genericSettings.decimal;
	if( regExDecimal == "\\&nbsp;" ) regExDecimal = "\\ ";
	var salaryActiveClass = ".active";
	var tabsArray = [];
	this.activeCalculator = null;
	this.currency = "Lek";
	this.activeCurrencySelect = $($(".defaultSelect").get(0));

	/**
	 * Global variables
	 *
	 */
	this.urlParams = {};

	/**
	 * Init component
	 *
	 */
	this.init = function() {

		// check calculator
		if( !$( "section.com16-9" ).length && !$( "section.com16-10" ).length && !$( "section.com16-8" ).length ) return;

		// change callback
		loan.changeCallback();

		// get URL query params
		loan.getUrlQueryStringParams();
		
		loan.setVisibleCalculatorAsActive();

		
		
		
		
		$(document).on('click', '[data-tab-default]', function () {
			$("li[data-tab]").removeClass("open");
			if($(this).attr("data-tab-default") == "true"){
				$('li[data-tab="with-salary"]', loan.activeCalculator).addClass("open");
				$('li[data-tab="with-salary"]', loan.activeCalculator).show();
			} else {
				$('li[data-tab="without-salary"]', loan.activeCalculator).addClass("open");
				$('li[data-tab="without-salary"]', loan.activeCalculator).show();
			}
		});
		
		$(document).on('keyup', 'input[data-algorithm-input="loanDuration"]', function () {
            var slider = $('.rangeslider.rangeslider--2', loan.activeCalculator);
            var index = parseInt(slider.attr('data-slider-index'));
            slider.slider('setValue', $(this).val(), true);
		});
		
		// on change borrow amount
		$( document ).on( "change focusin focusout", '*[data-algoritmInput="borrowAmount"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// on change currecy
		$( document ).on( "change", '*[data-algoritmInput="selectedCurrency"]', function( event ) {

			// prevent default
			event.preventDefault();
			
			loan.activeCurrencySelect = $(this);
			loan.currency = $( this ).val();
			if(loan.currency == "localCurrency"){
				loan.currency = "Lek";
			} 
			$(this).children().each(function(index, element){
				var attrValue = $(element).attr("value");
				if(attrValue == "localCurrency"){
					attrValue = "Lek";
				}
			    if(loan.currency == attrValue){
			    	$(element).attr("selected", "selected");
			    } else {
			    	$(element).removeAttr("selected");
			    }


			});
			// show/hide current currency input
			loan.changeCurrencyInput( $( this ).val() );

			// show/hide 2 years option if eur
			loan.updateInterestOptions( $( this ).val() );

			// change callback
			loan.changeCallback();

			// set selected currency as label
			loan.presentCurrency.text( loan.selectedCurrencyText );

			//switch select for mortgage
			if($("[data-select]", loan.activeCalculator).length>0){

				$("[data-select]", loan.activeCalculator).addClass("hide");
				$("[data-select="+loan.selectedCurrencyValue.toLowerCase()+"]", loan.activeCalculator).removeClass("hide");

			}
		});
			
			
		
		

		$(document).on('change', "[data-algorithm-input=newInterest] input", function(){
			var value = $( this ).val();
			if (value == "fixed") {
				$("input[name='repaymentOptions']").slider('setValue', loan.tenorMin);
			}
			$('*[data-algoritmInput="selectedInterestRate"]', loan.activeCalculator).val(value);
			$('*[data-algoritmInput="selectedInterestRate"]').trigger("change");
		});
		// on change interest rate
		$( document ).on( "change", '*[data-algoritmInput="selectedInterestRate"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// on change tenor
		$( document ).on( "change", '*[data-algoritmInput="tenor"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// on change car type
		$( document ).on( "change", '*[data-algoritmInput="selectedCar"] input', function( event ) {

			// prevent default
			event.preventDefault();

			// change tab
			var indexTabToOpen = parseInt( $( this ).attr( 'data-loan-open-tab' ) );
			loan.changeTab( indexTabToOpen );

			// trigger borrow amount correct currency
			$( '*[data-algoritmInput="selectedCurrency"]', loan.activeCalculator ).trigger( 'change' );

			// change callback
			loan.changeCallback();

		} );

		// on change salary
		$( document ).on( "click", '*[data-algoritmInput="salary"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// calculate action
		$( document ).on( "click", '*[data-algoritmInput="calculateBtn"]', function( event ) {

			// prevent default
			event.preventDefault();

			// change callback
			loan.changeCallback();

		} );

		// on change tab
		$( document ).on( "click", '.js-com16__toggle', function() {

			// change callback
			loan.changeCallback();

		} );

		// reset monthly installment input when tenor is clicked
		if( $( ".increaseHoverEffect" ).length == 2 ) {

			$( ".increaseHoverEffect" ).eq( 0 ).on( "click", function() {

				$( ".increaseHoverEffect" ).eq( 1 ).find( "input" ).val( "" );

			} );

		}

		// setup tabs
		loan.setupTabs();

		// fix slider buttons
		$( document ).on( "click", '.js-btnMinus', function() { $( '*[data-algoritmInput="tenor"]', loan.activeCalculator ).trigger( "change" ); } );
		$( document ).on( "click", '.js-btnAdd', function() { $( '*[data-algoritmInput="tenor"]', loan.activeCalculator ).trigger( "change" ); } );

		// fill inputs with query params
		loan.fillInputsWithQueryParams();
		
		$( document ).on( 'click', '.com15__filterItem', function() {
			var id = $( this ).attr( 'data-filter' );
			var width = $(window).width();
			var calculatorResolution = "desktop" ;
			if(width < 768){
				var calculatorResolution = "mobile" ;
			}
			var calculator = $( '.com15__filter[data-filter="' + id + '"]' ).find( '[data-calculator='+calculatorResolution+']');
		//	loan['loanpurpose'] = id;
			loan.setActiveCalculator( calculator );
			// change callback
			loan.changeCallback();

			// get URL query params
			loan.getUrlQueryStringParams();
			
			loan.setVisibleCalculatorAsActive();
			loan.setupTabs();
			loan.fillInputsWithQueryParams();

		} );

		

	};
	
	
	/**
	 * Set Active Calculator
	 *
	 */
	this.setActiveCalculator = function( calculator ) {

		loan.activeCalculator = calculator;

	};
	
	
	
	/**
	 * Set Visible Calculator As Active
	 *
	 */
	this.setVisibleCalculatorAsActive = function() {
		var width = $(window).width();
		var calculatorResolution = "desktop" ;
		if(width < 768){
			var calculatorResolution = "mobile" ;
		}
		var calculators = $( '[data-calculator='+calculatorResolution+']', loan.activeCalculator );
		var calculatorFound = false;

		calculators.each( function() {

			// set visible calculator as active
			if( $(this).is(":visible") ) {

				loan.activeCalculator = $( this );
				calculatorFound = true;

			}

		} );

		// handle no calculator active by default
		if( !calculatorFound ) loan.activeCalculator = $( '[data-calculator='+calculatorResolution+']', loan.activeCalculator ).first();

	};


	/**
	 * Get Url Query String Params
	 *
	 */
	this.getUrlQueryStringParams = function() {

		// get url
		var currentURL = window.location.href;
			currentURL = currentURL.split('?');

		// get query params
		var queryString = currentURL[1];

		// check query string not empty
		if( queryString !== undefined ) {

			var params = queryString.split('&');

			params.forEach( function( param ) {

				var property = param.split('=');
				var propertyName = property[0];
				var propertyValue = property[1];

				// set loan.urlParams property
				loan.urlParams[propertyName] = propertyValue;

			} );

		}

	};

	/**
	 * Fill Inputs With Query Params
	 *
	 */
	this.fillInputsWithQueryParams = function() {

		var thereAreQueryParams = $.isEmptyObject(loan.urlParams) ? false : true;

		if( thereAreQueryParams ) {

			// set currency
			loan.setCurrencyFromQuery();

			// set tab
			loan.setTabFromQuery();

			// set car condition
			loan.setCarConditionFromQuery();

			// set interest type
			loan.setInterestTypeFromQuery();

			// set loan amount
			loan.setLoanAmountFromQuery();

			// set tenor
			loan.setTenorFromQuery();

			// calculate
			loan.changeCallback();

		}

	};

	/**
	 * Set Tenor From Query
	 *
	 */
	this.setTenorFromQuery = function() {

		var tenor = parseInt( loan.urlParams.tenor );
		var tenorInput = $( '[data-algoritminput="tenor"]', loan.activeCalculator );

		if ( tenor && !isNaN(tenor) && tenorInput.length ) {

			// get step value
			var step = tenorInput.attr( 'data-slider-step' );
				step = parseInt( step );

			// round tenor based on step
			tenor = tenor - ( tenor % step );

			// set tenor
			var slider = window.sliderbootstrap[0];
			slider.slider( 'setValue', tenor, true );

		}

	};

	/**
	 * Set Loan Amount From Query
	 *
	 */
	this.setLoanAmountFromQuery = function() {

		var loanAmount = parseInt( loan.urlParams.loanAmount );
		var loanAmountInput = $( '[data-algoritminput="borrowAmount"]', loan.activeCalculator );

		if( loanAmount && !isNaN( loanAmount ) && loanAmountInput.length ) {

			var loanMin = loanAmountInput.attr( 'data-input-min' ) ? parseInt( loanAmountInput.attr( 'data-input-min' ) ) : 0;
			var loanMax = loanAmountInput.attr( 'data-input-max' ) ? parseInt( loanAmountInput.attr( 'data-input-max' ) ) : 100000000000000;

			if( loanAmount >= loanMin && loanAmount <= loanMax ) {
				loanAmountInput.val( loanAmount );
				loanAmountInput.parsley().validate();
			}

		}

	};

	/**
	 * Set Interest Type From Query
	 *
	 */
	this.setInterestTypeFromQuery = function() {

		var interestType = loan.urlParams.interestType;
		var interestTypeSelect = $( '[data-algoritminput="selectedInterestRate"]', loan.activeCalculator );
		var interestTypeOptionExists = $( '[data-algoritminput="selectedInterestRate"] option[value="' + interestType + '"]' , loan.activeCalculator).length ? true : false;
		var isInterestTypeOptionVisible = $( '[data-algoritminput="selectedInterestRate"] option[value="' + interestType + '"]' , loan.activeCalculator).css('display') === 'block';

		if( interestType && interestTypeSelect.length && interestTypeOptionExists && isInterestTypeOptionVisible ) {
			interestTypeSelect.val( interestType );
		}

	};

	/**
	 * Set Car Condition From Query
	 *
	 */
	this.setCarConditionFromQuery = function() {

		var carCondition = loan.urlParams.carCondition;
		var carConditionInput = $( '[data-algoritminput="selectedCar"]', loan.activeCalculator );
		var carConditionInputOption = $( '[data-algoritminput="selectedCar"] input[value="' + carCondition + '"]', loan.activeCalculator );

		if( carCondition && carConditionInput.length && carConditionInputOption.length ) {
			carConditionInputOption.trigger('click');
		}

	};

	/**
	 * Set Currency From Query
	 *
	 */
	this.setCurrencyFromQuery = function() {

		var currency = loan.urlParams.currency;
		var currencySelect = $( '[data-algoritminput="selectedCurrency"]', loan.activeCalculator );
		var currencyOptionExists = $( '[data-algoritminput="selectedCurrency"] option[value="' + currency + '"]', loan.activeCalculator ).length ? true : false;

		if( currency && currencySelect.length && currencyOptionExists ) {

			currencySelect.val( currency );
			currencySelect.trigger( 'change' );

		}

	};

	/**
	 * Set Tab From Query
	 *
	 */
	this.setTabFromQuery = function() {

		var isDefaultTab = loan.urlParams.isDefault === 'false' ? false : true;
		var withoutSalaryTab = $( '[data-tab="without-salary"] > a', loan.activeCalculator );
		var isWithoutSalaryTabVisible = withoutSalaryTab.is(":visible");

		if( isWithoutSalaryTabVisible && !isDefaultTab ) {
			withoutSalaryTab.trigger('click');
		}

	};

	/**
	 * Change input callback
	 *
	 */
	this.changeCallback = function() {

	    var calculatorNavigation = Intesa.CalculatorNavigation.getInstance(loan.activeCalculator);
	    calculatorNavigation.init();
		// disable basket buttons
	    
		$( "*[data-generate-cookie]" ).attr( "data-enabled", "false" );

		// get inputs
		loan.getInputs( salaryActiveClass );

		// check errors
		if( loan.borrowAmount.hasClass( "parsley-error" ) ) return;

		// init output elements
		loan.initOutputElements();

		// calculate
		loan.calculateLoan();

		// show results
		loan.fillOutputElements();

		// setup table rows
		loan.setupTableRows();

		// enable basket buttons
		$( "*[data-generate-cookie]" ).removeAttr( "data-enabled" );

		// update share calculator
		loan.updateShareCalculatorLink();

	};


	/**
	 * Update Share Calculator Link
	 *
	 */
	this.updateShareCalculatorLink = function() {

		// get url without query string
		var currentURL = window.location.href;
			currentURL = currentURL.split('?');
			currentURL = currentURL[0];

		// get data
		var currency = $( '[data-algoritminput="selectedCurrency"]', loan.activeCalculator ).val();

		// add standard query params
		var queryParams = '?loanAmount=' + loan.borrowAmountValue + '&tenor=' + loan.tenorValue + '&currency=' + currency + '&interestType=' + loan.selectedInterestRateValue;

		// without salary case
		var isWithoutSalaryTab = $( '[data-tab="without-salary"]', loan.activeCalculator ).hasClass( 'open' );
		if( isWithoutSalaryTab ) queryParams += '&isDefault=false';

		// car condition
		if( $( '[data-algoritminput="selectedCar"]', loan.activeCalculator ).length ) {
			var carCondition = $( 'input[value="new"]' , loan.activeCalculator).prop( 'checked' ) ? 'new' : 'used';
			queryParams += '&carCondition=' + carCondition;
		}

		// update link
		//$( '#share-calculator' ).text( currentURL + queryParams );

	};

	/**
	 * Update Slider with different tenor min & max
	 *
	 */
		this.updateSliderTenor = function() {

			if (loan.selectedInterestRateValue == "fixed") {
				loan.tenorMin = Number($("input[data-algoritmInput='min-tenor-fixed']").val());
				loan.tenorMax = Number($("input[data-algoritmInput='max-tenor-fixed']").val());
				$("li[data-name='variableInterestRateRemainingPeriod']").css("display", "none")
			} else {
				if (loan.selectedInterestRateValue == "5yfixed+variable") {
					loan.tenorMin = loan.tenorMin + 1;
					if (loan.tenorValue <= 60) {
						$("input[name='repaymentOptions']").slider('setValue', loan.tenorMin + 1);
					}
				}
				$("li[data-name='variableInterestRateRemainingPeriod']").css("display", "")
			}
			$("input[name='repaymentOptions']").slider('setAttribute', 'min', loan.tenorMin);
			$("input[name='repaymentOptions']").slider('setAttribute', 'max', loan.tenorMax);
			$("section[data-component='SliderRange'] .pull-left b").html(loan.tenorMin);
			$("section[data-component='SliderRange'] .pull-right b").html(loan.tenorMax);

		};


	/**
	 * Change currency input
	 *
	 */
	this.changeCurrencyInput = function( newCurrency ) {
		// not used
		// hide inputs and clear data-algoritminput
		var inputsContainers = $( '*[data-currency-input-container]', loan.activeCalculator );
		inputsContainers.addClass( 'hide' );
		$("[data-currency-name]", loan.activeCalculator).attr("data-algoritminput", "");

		// show correct input and activate data-algoritminput
		$("[data-currency-name=" + newCurrency + "]", loan.activeCalculator).parents( '*[data-currency-input-container]' ).removeClass( 'hide' );
		$("[data-currency-name=" + newCurrency + "]", loan.activeCalculator).attr("data-algoritminput", "borrowAmount");
		$("[data-currency-name=" + newCurrency + "]", loan.activeCalculator).parent().find('[data-algoritminput=selectedCurrency]').val(newCurrency);
	};


	/**
	 * Update interest options
	 *
	 */
	this.updateInterestOptions = function( currentCurrency ) {

		// get twoYearsFixed option
		var twoYearsFixed = $("*[data-algoritmInput='selectedInterestRate'] option[value='2yfixed+variable']", loan.activeCalculator);

		var twoYearsRadio = $("*label[for='2yfixed+variable']", loan.activeCalculator).parent().parent();

		if( twoYearsFixed.length ) {

			// hide twoYearsFixed option for eur
			if( currentCurrency === "eur" ) {

				twoYearsFixed.css('display', 'none');
				twoYearsRadio.css('display', 'none');

				$($(".section__form--radioinline .section__form__inline")[0]).children().children().click()

				// reset first options
				if( $( '[data-algoritminput="selectedInterestRate"]', loan.activeCalculator ).val() === '2yfixed+variable' ) {
					$("*[data-algoritmInput='selectedInterestRate']", loan.activeCalculator).val( '1yfixed+variable' );
				}

			} else {

				twoYearsFixed.css('display', 'block');
				twoYearsRadio.css('display', 'block');

			}

		}

	};


	/**
	 * Setup tabs
	 *
	 */
	this.setupTabs = function() {

		if( $( '*[data-loan-tab-container]', loan.activeCalculator ).length ) {

			// select all tabs
			var tabs = $( '*[data-loan-tab]', loan.activeCalculator );

			// add each tab inside tabsArray
			tabs.each( function() {

				var tabIndex = parseInt( $( this ).attr( 'data-loan-tab' ) );
				var tabContent = $( this )[0];

				tabsArray.push( {
					"index": tabIndex,
					"content" : tabContent
				} );

				//$(this).remove();

			} );

			// set first tab to show
			loan.changeTab( 0 );

		 }

	};


	/**
	 * Change tab
	 *
	 */
	this.changeTab = function( indexTabToOpen ) {

		// select tabs container
		var tabsContainer = $( '*[data-loan-tab-container]', loan.activeCalculator );

		// remove old tab but preserve events with detach
		$( '*[data-loan-tab]' , loan.activeCalculator).detach();

		// find new tab and activate it
		$.each( tabsArray, function() {

			var currentTabIndex = $( this )[0].index;

			if( currentTabIndex == indexTabToOpen ) {

				var currentTabContent = $( this )[0].content;

				tabsContainer.append( currentTabContent );

			}

		} );

	};


	/**
	 * Setup table rows show/hide
	 *
	 */
	this.setupTableRows = function() {

		// select all rows to show/hide
		var rows = $( '[data-name]', loan.activeCalculator );

		// select current currency value
		var currency = $( '[data-algoritminput="selectedCurrency"]', loan.activeCalculator ).val();

		// get rows to display array
		var rowsToDisplay = JSON.parse( $( '[data-algoritminput="rowsToDisplay"]', loan.activeCalculator ).val() );
			rowsToDisplay = rowsToDisplay[currency];

		// hide all the rows
		rows.hide();

		// show rows included inside rowsToDisplay array
		rows.each( function() {

			var $this = $( this );
			var current = $this.attr( 'data-name' );

			if( $.inArray( current, rowsToDisplay) !== -1 ) {
				$this.show();
			}

		});

	};


	/**
	 * Show/hide second tab
	 *
	 */
	this.showHideTab = function(action) {

		if(action=="show"){
			console.log("show it!");
			$('[data-tab="without-salary"],[data-tab="with-salary"]', loan.activeCalculator).show();
			$('section.section.com16-8').addClass("com16-2").removeClass("com16-8");

		}

		if(action=="hide"){
			console.log("hide it!");
			$('[data-tab="without-salary"],[data-tab="with-salary"]', loan.activeCalculator).hide();
			$('[data-tab="with-salary"]', loan.activeCalculator).show();
			$('[data-tab="without-salary"]', loan.activeCalculator).removeClass("open");
			$('[data-tab="with-salary"]', loan.activeCalculator).addClass("open");

			// Prevent open/close bug on mobile devices
			if( !( $( '[data-tab="with-salary"]', loan.activeCalculator ).hasClass( 'open' ) ) ) {
				$('[data-tab="with-salary"]', loan.activeCalculator).show();
			}

			$('section.section.com16-2').addClass("com16-8").removeClass("com16-2");
		}

	};

	/* --------------------- */

	/**
	 * Calculate loan
	 *
	 */
	this.calculateLoan = function() {

		// set commons output results
		loan.interestRateFirstPeriodResult = number_format( loan.interestRateFirstPeriod, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );
		loan.interestRateRemainingPeriodResult = number_format( loan.interestRateRemainingPeriod, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );
		loan.promoInterestRateFirstPeriodResult = number_format( loan.promoInterestRateFirstPeriod, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );
		loan.promoInterestRateRemainingPeriodResult = number_format( loan.promoInterestRateRemainingPeriod, genericSettings.decimals_number, genericSettings.decimal_number, genericSettings.separator_number );

		// log
		console.log( "---------------------" );
		console.log( "FORMULA ALBANIA" );
		console.log( "---------------------" );

		// calculate the scaled interest rate
		loan.scaledInterestRateValuePromo = loan.calculateScaledInterestRate( loan.promoInterestRateFirstPeriod );
		loan.scaledInterestRateValueStandard = loan.calculateScaledInterestRate( loan.interestRateFirstPeriod );
		loan.scaledInterestRateValuePromo2 = loan.calculateScaledInterestRate( loan.promoInterestRateRemainingPeriod );
		loan.scaledInterestRateValueStandard2 = loan.calculateScaledInterestRate( loan.interestRateRemainingPeriod );

		// log
		console.log( "Scaled Interest Rate Value Promo first period: " + loan.scaledInterestRateValuePromo + " - " + typeof( loan.scaledInterestRateValuePromo ) );
		console.log( "Scaled Interest Rate Value Sandard first period: " + loan.scaledInterestRateValueStandard + " - " + typeof( loan.scaledInterestRateValueStandard ) );
		console.log( "Scaled Interest Rate Value Promo Remaining period: " + loan.scaledInterestRateValuePromo2 + " - " + typeof( loan.scaledInterestRateValuePromo2 ) );
		console.log( "Scaled Interest Rate Value Sandard Remaining period: " + loan.scaledInterestRateValueStandard2 + " - " + typeof( loan.scaledInterestRateValueStandard2 ) );

		// init local variables
		var loanAmountCalculatedPromo,
			loanAmountCalculatedStandard,
			tenorCalculatedPromo,
			tenorCalculatedStandard;

		tenorCalculatedPromo = tenorCalculatedStandard = loan.tenorValue;
		loanAmountCalculatedPromo = loanAmountCalculatedStandard = loan.borrowAmountValue;

		loan.tenorCalculatedPromo = tenorCalculatedPromo;
		loan.tenorCalculatedStandard = tenorCalculatedStandard;
		loan.loanAmountCalculatedPromo = loanAmountCalculatedPromo;
		loan.loanAmountCalculatedStandard = loanAmountCalculatedStandard;

		// log
		console.log( "Tenor Calculated Value Promo: " + tenorCalculatedPromo + " - " + typeof( tenorCalculatedPromo ) );
		console.log( "Tenor Calculated Value Standard: " + tenorCalculatedStandard + " - " + typeof( tenorCalculatedStandard ) );
		console.log( "Loan Amount Value Promo: " + loanAmountCalculatedPromo + " - " + typeof( loanAmountCalculatedPromo ) );
		console.log( "Loan Amount Value Sandard: " + loanAmountCalculatedStandard + " - " + typeof( loanAmountCalculatedStandard ) );

		// check validity
		if( validPromoResults ) {

			// set partial output results
			loan.loanAmountResultPromo = number_format( loanAmountCalculatedPromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );
			loan.tenorResultPromo = number_format( tenorCalculatedPromo, 0, genericSettings.decimal_number, genericSettings.separator_number );

			// calculate the monthly installment only if the tenor is valid and the loan amount is greater then the minimum given
			if( !isNaN( tenorCalculatedPromo ) && ( loanAmountCalculatedPromo >= loan.borrowAmountMin ) ) {

				// calculate the monthly installment for the first period

				loan.monthlyInstallmentValuePromo = loan.calculateMonthlyInstallment( loan.scaledInterestRateValuePromo, loanAmountCalculatedPromo, tenorCalculatedPromo );

				// log
				console.log( "Monthly Installment Value Promo first period: " + loan.monthlyInstallmentValuePromo + " - " + typeof( loan.monthlyInstallmentValuePromo )  );

				// set partial output results
				loan.monthlyInstallmentResultPromo = number_format( loan.monthlyInstallmentValuePromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				// check monthly valid
				if( !isNaN( loan.monthlyInstallmentValuePromo ) ) {

					// calculate amount to repay
					loan.amountToRepayValuePromo = loan.calculataAmountToRepay( loan.monthlyInstallmentValuePromo, tenorCalculatedPromo );

					// log
					console.log( "Amount to Repay Value Promo first period: " + loan.amountToRepayValuePromo + " - " + typeof( loan.amountToRepayValuePromo ) );

					// set partial output results
					loan.amountToRepayResultPromo = number_format( loan.amountToRepayValuePromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

					// check amount to repay valid
					if( isNaN( loan.amountToRepayValuePromo ) ) validPromoResults = false;

				} else {

					validPromoResults = false;

				}

				if(loan.scaledInterestRateValuePromo2>0){

					//if the remaining period has the same rate as the first period, calculate only once
					var differentSecondPeriod = null;

					if (loan.scaledInterestRateValuePromo2 !== loan.scaledInterestRateValuePromo){

						differentSecondPeriod = "promo";

					}

					// calculate the monthly installment for the remaining period
					loan.monthlyInstallmentValuePromo2 = loan.calculateMonthlyInstallment( loan.scaledInterestRateValuePromo2, loanAmountCalculatedPromo, tenorCalculatedPromo, differentSecondPeriod );

					// log
					console.log( "Monthly Installment Value Promo remaining period: " + loan.monthlyInstallmentValuePromo2 + " - " + typeof( loan.monthlyInstallmentValuePromo2 )  );

					// set partial output results
					loan.monthlyInstallmentResultPromo2 = number_format( loan.monthlyInstallmentValuePromo2, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

					// check monthly valid
					if( !isNaN( loan.monthlyInstallmentValuePromo2 ) ) {

						// calculate amount to repay
						loan.amountToRepayValuePromo2 = loan.calculataAmountToRepay( loan.monthlyInstallmentValuePromo2, tenorCalculatedPromo );

						// log
						console.log( "Amount to Repay Value Promo remaining period: " + loan.amountToRepayValuePromo2 + " - " + typeof( loan.amountToRepayValuePromo2 ) );

						// set partial output results
						loan.amountToRepayResultPromo2 = number_format( loan.amountToRepayValuePromo2, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

						// check amount to repay valid
						if( isNaN( loan.amountToRepayValuePromo2 ) ) validPromoResults = false;

					} else {

						validPromoResults = false;

					}

				}	else{

					loan.monthlyInstallmentResultPromo2=undefined;

				}

			} else {

				validPromoResults = false;

			}

			//the amountToRepayValuePromo for the firt and the remaining period
			if( (loan.amountToRepayValuePromo!==loan.amountToRepayValuePromo2) && !isNaN( loan.amountToRepayValuePromo ) && !isNaN( loan.amountToRepayValuePromo2 ) && ( loan.scaledInterestRateValuePromo2 > 0) ){

				loan.amountToRepayValuePromo = loan.monthlyInstallmentValuePromo * loan.firstPeriodDurationPromo + loan.monthlyInstallmentValuePromo2 * loan.remainingPeriodDurationPromo;

				loan.amountToRepayResultPromo = number_format( loan.amountToRepayValuePromo, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				console.log("Total amountToRepayValuePromo for both periods: "+loan.amountToRepayValuePromo);

			}

		}

		if( validStandardResults ) {

			// set partial output results
			loan.loanAmountResultStandard = number_format( loanAmountCalculatedStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );
			loan.tenorResultStandard = number_format( tenorCalculatedStandard, "0", genericSettings.decimal_number, genericSettings.separator_number );

			// calculate the monthly installment only if the tenor is valid and the loan amount is greathen then the minimum given
			if( !isNaN( tenorCalculatedStandard ) && ( loanAmountCalculatedStandard >= loan.borrowAmountMin ) ) {

				// calculate the monthly installment standard for the first period
				loan.monthlyInstallmentValueStandard = loan.calculateMonthlyInstallment( loan.scaledInterestRateValueStandard, loanAmountCalculatedStandard, tenorCalculatedStandard );

				// log
				console.log( "Monthly Installment Value Standard for the first period: " + loan.monthlyInstallmentValueStandard + " - " + typeof( loan.monthlyInstallmentValueStandard )  );

				// set partial output results
				loan.monthlyInstallmentResultStandard = number_format( loan.monthlyInstallmentValueStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				// check monthly valid
				if( !isNaN( loan.monthlyInstallmentValueStandard ) ) {

					// calculate amount to repay
					loan.amountToRepayValueStandard = loan.calculataAmountToRepay( loan.monthlyInstallmentValueStandard, tenorCalculatedStandard );

					// log
					console.log( "Amount to Repay Value Standard for the first period: " + loan.amountToRepayValueStandard + " - " + typeof( loan.amountToRepayValueStandard ) );

					// set partial output results
					loan.amountToRepayResultStandard = number_format( loan.amountToRepayValueStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

					// check amount to repay valid
					if( isNaN( loan.amountToRepayValueStandard ) ) validStandardResults = false;

				} else {

					validStandardResults = false;

				}

				if(loan.scaledInterestRateValueStandard2>0){

					//if the remaining period has the same rate as the first period, calculateit only once
					var differentSecondPeriod = null;
					if (loan.scaledInterestRateValueStandard2 !== loan.scaledInterestRateValueStandard){

						differentSecondPeriod = "standard";

					}

					// calculate the monthly installment standard for the remaining period
					loan.monthlyInstallmentValueStandard2 = loan.calculateMonthlyInstallment( loan.scaledInterestRateValueStandard2, loanAmountCalculatedStandard, tenorCalculatedStandard, differentSecondPeriod );

					// log
					console.log( "Monthly Installment Value Standard for the remaining period: " + loan.monthlyInstallmentValueStandard2 + " - " + typeof( loan.monthlyInstallmentValueStandard2 )  );

					// set partial output results
					loan.monthlyInstallmentResultStandard2 = number_format( loan.monthlyInstallmentValueStandard2, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

					// check monthly valid
					if( !isNaN( loan.monthlyInstallmentValueStandard2 ) ) {

						// calculate amount to repay
						loan.amountToRepayValueStandard2 = loan.calculataAmountToRepay( loan.monthlyInstallmentValueStandard2, tenorCalculatedStandard );

						// log
						console.log( "Amount to Repay Value Standard for the remaining period: " + loan.amountToRepayValueStandard2 + " - " + typeof( loan.amountToRepayValueStandard2 ) );

						// set partial output results
						loan.amountToRepayResultStandard2 = number_format( loan.amountToRepayValueStandard2, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

						// check amount to repay valid
						if( isNaN( loan.amountToRepayValueStandard2 ) ) validStandardResults = false;

					} else {

						validStandardResults = false;

					}

				}	else{

					loan.monthlyInstallmentResultStandard2=undefined;

				}

			} else {

				validStandardResults = false;

			}

			//the amountToRepayValueStandard for the firt and the remaining period
			if( (loan.amountToRepayValueStandard!==loan.amountToRepayValueStandard2) && !isNaN( loan.amountToRepayValueStandard ) && !isNaN( loan.amountToRepayValueStandard2 ) && ( loan.scaledInterestRateValueStandard2 > 0) ){

				loan.amountToRepayValueStandard = loan.monthlyInstallmentValueStandard * loan.firstPeriodDurationStandard + loan.monthlyInstallmentValueStandard2 * loan.remainingPeriodDurationStandard;

				loan.amountToRepayResultStandard = number_format( loan.amountToRepayValueStandard, genericSettings.decimals, genericSettings.decimal, genericSettings.separator );

				console.log("Total amountToRepayValueStandard for both periods: "+loan.amountToRepayValueStandard);

			}

		}

	};

	/**
	 * Calculate Scaled Interest Rate
	 *
	 * @param {*} interestRate
	 */
	this.calculateScaledInterestRate = function( interestRate ) {

		return Number( interestRate * 31 / 365 / 100 );

	};

	/**
	 * Calculate Monthly Installment
	 *
	 * @param {*} scaledInterestRate
	 * @param {*} borrowAmount
	 * @param {*} tenor
	 */
	this.calculateMonthlyInstallment = function( scaledInterestRate, borrowAmount, tenor, numPeriod ) {

		var monthlyInstallmentFormula = NaN;

		if( ( borrowAmount !== null ) && ( borrowAmount !== "0" ) &&
			( scaledInterestRate !== null ) && ( scaledInterestRate !== "0" ) &&
			( tenor !== null ) && ( tenor !== "0" ) ) {

			if( ( tenor > loan.tenorMax ) ||
			 	( tenor < loan.tenorMin ) ) {

				monthlyInstallmentFormula = NaN;

			} else {

				if (numPeriod!==null && numPeriod!==undefined){

					//console.log("different interest rate");

					if (numPeriod=="promo"){

						var balance = borrowAmount;
						var interest = 0, principal = 0, paymentDue = 0;

						paymentDue = loan.monthlyInstallmentValuePromo;

						for (var i=1;i<=loan.firstPeriodDurationPromo;i++){

							interest = Number ( parseFloat(loan.scaledInterestRateValuePromo*balance).toFixed(2) );
							principal = paymentDue - interest;
							balance = balance - principal;

						}

						monthlyInstallmentFormula = scaledInterestRate * balance * Math.pow((1 + scaledInterestRate), tenor-loan.firstPeriodDurationPromo) / (1 - Math.pow((1 + scaledInterestRate), tenor-loan.firstPeriodDurationPromo));

					}

					if (numPeriod=="standard"){

						var balance = borrowAmount;
						var interest = 0, principal = 0, paymentDue = 0;

						paymentDue = loan.monthlyInstallmentValueStandard;

						for (var i=1;i<=loan.firstPeriodDurationStandard;i++){

							interest = Number ( parseFloat(loan.scaledInterestRateValueStandard*balance).toFixed(2) );
							principal = paymentDue - interest;
							balance = balance - principal;

						}

						monthlyInstallmentFormula = scaledInterestRate * balance * Math.pow((1 + scaledInterestRate), tenor-loan.firstPeriodDurationStandard) / (1 - Math.pow((1 + scaledInterestRate), tenor-loan.firstPeriodDurationStandard));

					}

				} else{

					//console.log("same interest rate");
					monthlyInstallmentFormula = scaledInterestRate * borrowAmount * Math.pow((1 + scaledInterestRate), tenor) / (1 - Math.pow((1 + scaledInterestRate), tenor));

				}

			}

		}

		monthlyInstallmentFormula = monthlyInstallmentFormula.toFixed( 2 );
		monthlyInstallmentFormula = monthlyInstallmentFormula * -1;
		return Number( monthlyInstallmentFormula );

	};

	/**
	 * Calculate Amount to Repay
	 *
	 * @param {*} monthlyInstallment
	 * @param {*} tenor
	 */
	this.calculataAmountToRepay = function( monthlyInstallment, tenor ) {

		var amountToRepayFormula = NaN;

		if( ( monthlyInstallment !== null ) && ( monthlyInstallment !== "0" ) ) {

			amountToRepayFormula = monthlyInstallment * tenor;

		}

		return Number( amountToRepayFormula );

	};

	/* --------------------- */

	/**
	 * Init output elements
	 *
	 */
	this.initOutputElements = function() {

		loan.setOutputElements();
		loan.resetOutputElements();

	};

	/**
	 * Set output elements
	 *
	 */
	this.setOutputElements = function() {

		loan.setOutputElementsPromo();
		loan.setOutputElementsStandard();

	};

	/**
	 * Set output elements Promo
	 *
	 */
	this.setOutputElementsPromo = function() {

		// promo
		loan.monthlyInstallmentPromoFirstPeriod = $( '*[data-algoritmResult="monthlyInstallmentFirstPeriodPromo"]', loan.activeCalculator );
		loan.monthlyInstallmentPromoRemainingPeriod = $( '*[data-algoritmResult="monthlyInstallmentRemainingPeriodPromo"]', loan.activeCalculator );

		loan.fixedInterestRatePromoFirstPeriod = $( '*[data-algoritmResult="fixedInterestRateFirstPeriodPromo"]', loan.activeCalculator );
		loan.variableInterestRatePromo = $( '*[data-algoritmResult="variableInterestRatePromo"]', loan.activeCalculator );
		loan.fixedInterestRatePromoRemainingPeriod = $( '*[data-algoritmResult="fixedInterestRateRemainingPeriodPromo"]', loan.activeCalculator );
		loan.variableInterestRatePromoRemainingPeriod = $( '*[data-algoritmResult="variableInterestRateRemainingPeriodPromo"]', loan.activeCalculator );

		loan.fixedInterestRateStandardFirstPeriod = $( '*[data-algoritmResult="fixedInterestRateFirstPeriodStandard"]', loan.activeCalculator );
		loan.variableInterestRateStandard = $( '*[data-algoritmResult="variableInterestRateStandard"]', loan.activeCalculator );
		loan.fixedInterestRateStandardRemainingPeriod = $( '*[data-algoritmResult="fixedInterestRateRemainingPeriodStandard"]', loan.activeCalculator );
		loan.variableInterestRateStandardRemainingPeriod = $( '*[data-algoritmResult="variableInterestrateRemainingPeriodStandard"]', loan.activeCalculator );

		loan.loanAmountPromo = $( '*[data-algoritmResult="loanAmountPromo"]', loan.activeCalculator );
		loan.amountToRepayPromo = $( '*[data-algoritmResult="amountToRepayPromo"]', loan.activeCalculator );
		loan.tenorPromo = $( '*[data-algoritmResult="tenorPromo"]', loan.activeCalculator );
		loan.interestRatePromo = $( '*[data-algoritmResult="interestRatePromo"]', loan.activeCalculator );
		loan.aprPromo = $( '*[data-algoritmResult="aprPromo"]', loan.activeCalculator );
		loan.getButton = $( "*[data-generate-cookie]", loan.activeCalculator );
		loan.callButton = $( "*[data-tab] .com16__buttonCover .call-btn", loan.activeCalculator );

	};

	/**
	 * Set output elements Standard
	 *
	 */
	this.setOutputElementsStandard = function() {

		// standard
		loan.monthlyInstallmentStandardFirstPeriod = $( '*[data-algoritmResult="monthlyInstallmentFirstPeriodStandard"]', loan.activeCalculator );
		loan.monthlyInstallmentStandardRemainingPeriod = $( '*[data-algoritmResult="monthlyinstallmentRemainingPeriodStandard"]', loan.activeCalculator );
		loan.loanAmountStandard = $( '*[data-algoritmResult="loanAmountStandard"]', loan.activeCalculator );
		loan.amountToRepayStandard = $( '*[data-algoritmResult="amountToRepayStandard"]', loan.activeCalculator );
		loan.tenorStandard = $( '*[data-algoritmResult="tenorStandard"]', loan.activeCalculator );
		loan.interestRateStandard = $( '*[data-algoritmResult="interestRateStandard"]', loan.activeCalculator );
		loan.aprStandard = $( '*[data-algoritmResult="aprStandard"]', loan.activeCalculator );

	};

	/**
	 * Reset output elements
	 *
	 */
	this.resetOutputElements = function() {

		loan.resetOutputElementsPromo();
		loan.resetOutputElementsStandard();

	};

	/**
	 * Reset output elements Promo
	 *
	 */
	this.resetOutputElementsPromo = function() {

		validPromoResults = true;

		loan.monthlyInstallmentResultPromo = undefined;
		loan.loanAmountResultPromo = undefined;
		loan.amountToRepayResultPromo = undefined;
		loan.amountToRepayResultPromo2 = undefined;
		loan.tenorResultPromo = undefined;
		loan.interestRateResultPromo = undefined;


		loan.monthlyInstallmentPromoFirstPeriod.text( resetString );
		loan.monthlyInstallmentPromoRemainingPeriod.text( resetString );

		loan.fixedInterestRatePromoFirstPeriod.text( resetString );
		loan.variableInterestRatePromo.text( resetString );
		loan.fixedInterestRatePromoRemainingPeriod.text( resetString );
		loan.variableInterestRatePromoRemainingPeriod.text( resetString );

		loan.fixedInterestRateStandardFirstPeriod.text( resetString );
		loan.variableInterestRateStandard.text( resetString );
		loan.fixedInterestRateStandardRemainingPeriod.text( resetString );
		loan.variableInterestRateStandardRemainingPeriod.text( resetString );

		loan.loanAmountPromo.text( resetString );
		loan.amountToRepayPromo.text( resetString );
		loan.tenorPromo.text( resetString );
		loan.interestRatePromo.text( resetString );
		loan.aprPromo.text( resetString );

		//loan.toggleShopBtn( loan.getButton, "hide" );- not needed at this point
		loan.callButton.show();

	};

	/**
	 * Reset output elements Standard
	 *
	 */
	this.resetOutputElementsStandard = function() {

		validStandardResults = true;

		loan.monthlyInstallmentResultStandard = undefined;
		loan.loanAmountResultStandard = undefined;
		loan.amountToRepayResultStandard = undefined;
		loan.tenorResultStandard = undefined;
		loan.interestRateResultStandard = undefined;

		loan.monthlyInstallmentStandardFirstPeriod.text( resetString );
		loan.monthlyInstallmentStandardRemainingPeriod.text( resetString );
		loan.loanAmountStandard.text( resetString );
		loan.amountToRepayStandard.text( resetString );
		loan.tenorStandard.text( resetString );
		loan.interestRateStandard.text( resetString );
		loan.aprStandard.text( resetString );

	};

	/* --------------------- */

	/**
	 * Get inputs
	 *
	 * @param {*} salaryActiveClass
	 */
	this.getInputs = function( salaryActiveClass ) {

		// log
		console.log( "---------------------" );
		console.log( "CALCULATOR INPUTS ALBANIA" );
		console.log( "---------------------" );

		//Product Category
		loan.productCategory = $( '*[data-algoritmInput="productCategory"]', loan.activeCalculator );
		loan.productCategoryValue = loan.productCategory.val();

		//Car type
		loan.selectedCar = $( '*[data-algoritmInput="selectedCar"]', loan.activeCalculator );
		loan.selectedCarValue = loan.selectedCar.find('input[name=selectedCar]:checked').val();

		//Selected Currency
		loan.selectedCurrency = loan.activeCurrencySelect;
		loan.selectedCurrencyValue = loan.selectedCurrency.val();
		loan.selectedCurrencyText = loan.activeCurrencySelect.children(' option:selected' ).text();

		//Preset Currency labels
		loan.presentCurrency = $( '*[data-currency]', loan.activeCalculator );

		//Selected Interest Rate
		loan.selectedInterestRate = $( '*[data-algoritmInput="selectedInterestRate"]', loan.activeCalculator );
		loan.selectedInterestRateValue = loan.selectedInterestRate.val();

		//Interest rate
		loan.interestRate = $( '*[data-algoritmInput="interestRate"]', loan.activeCalculator );
		loan.interestRateValue =  JSON.parse( stripslashes( loan.interestRate.val() ) );

		// tenor
		loan.tenor = $( '*[data-algoritmInput="tenor"]' , loan.activeCalculator);
		loan.tenorValue = Number( loan.tenor.val() );
		loan.tenorMin = Number(loan.tenor.attr("data-slider-min"));
		loan.tenorMax = Number(loan.tenor.attr("data-slider-max"));
		loan.tenorStep = Number( loan.tenor.attr( "data-slider-step" ) );
		// log
		console.log( "Tenor Value: " + loan.tenorValue + " - " + typeof( loan.tenorValue ) );
		console.log( "Tenor Min Value: " + loan.tenorMin + " - " + typeof( loan.tenorMin ) );
		console.log( "Tenor Max Value: " + loan.tenorMax + " - " + typeof( loan.tenorMax ) );
		console.log( "Tenor Step Value: " + loan.tenorStep + " - " + typeof( loan.tenorStep ) );

		loan.updateSliderTenor();

		//Interest rate for the first and for the Remaining period (by category type)
		switch(loan.productCategoryValue) {

			case "PERSONAL_LOAN":

				console.log("PERSONAL_LOAN");

				if (loan.selectedCurrencyValue=="eur"){

					loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur ) );
					loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
					loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;
					loan.promoInterestRateRemainingPeriod = loan.interestRateFirstPeriod;

					loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.salary_customers.interest_rate[0] ) );
					
					var customersPeriods = loan.interestRateValue.eurCurrency.salary_customers.period;

					for(i = 0; i < customersPeriods.length; i++){
						if(loan.tenorValue > 36){
							if(customersPeriods[i] > 36 && i > 0 && 
									(loan.tenorValue > 36 && customersPeriods[i] == 60 && loan.tenorValue <= 60 
											|| loan.tenorValue > 60 && customersPeriods[i] == 84 && loan.tenorValue <= 84)){
		
								loan.promoInterestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.salary_customers.interest_rate[i][1] ) );
								loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.salary_customers.interest_rate[i][0] ) );
							} 
						} else {
							if (loan.tenorValue == customersPeriods[i] && loan.tenorValue <= 36){
								loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.salary_customers.interest_rate[i] ) );
							} else if(loan.tenorValue > customersPeriods[i] && loan.tenorValue < customersPeriods[i+1] && customersPeriods[i+1] <= 36){
								loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.salary_customers.interest_rate[i+1] ) );
							}

						}
					}
					// in caso di euro other customer = lek user customer
					loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.other_customers.interest_rate[0] ) );
					
					var otherCustomersPeriods = loan.interestRateValue.eurCurrency.other_customers.period;

					for(i = 0; i < otherCustomersPeriods.length; i++){
						if(loan.tenorValue > 36){
							if(otherCustomersPeriods[i] > 36 && i > 0 && 
									(loan.tenorValue > 36 && otherCustomersPeriods[i] == 60 && loan.tenorValue <= 60 
											|| loan.tenorValue > 60 && otherCustomersPeriods[i] == 84 && loan.tenorValue <= 84)){
		
								loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.other_customers.interest_rate[i][1] ) );
								loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.other_customers.interest_rate[i][0] ) );
							} 
						} else {
							if (loan.tenorValue == otherCustomersPeriods[i]  && loan.tenorValue <= 36){
								loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.other_customers.interest_rate[i] ) );
							} else if(loan.tenorValue > otherCustomersPeriods[i] && loan.tenorValue < otherCustomersPeriods[i+1] && otherCustomersPeriods[i+1] <= 36){
								loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eurCurrency.other_customers.interest_rate[i+1] ) );
							}
						}
					}
					
					if(loan.tenorValue <= 36){
						loan.promoInterestRateRemainingPeriod = undefined;
						loan.interestRateRemainingPeriod = undefined;
					}
					//show the second tab
					loan.showHideTab("show");

				}

				if (loan.selectedCurrencyValue== "localCurrency"){

					loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.other_customers.interest_rate[0] ) );
					
					var otherCustomersPeriods = loan.interestRateValue.localCurrency.other_customers.period;

					for(i = 0; i < otherCustomersPeriods.length; i++){
						if(loan.tenorValue > 36){
							if(otherCustomersPeriods[i] > 36 && i > 0 && 
									(loan.tenorValue > 36 && otherCustomersPeriods[i] == 60 && loan.tenorValue <= 60 
											|| loan.tenorValue > 60 && otherCustomersPeriods[i] == 84 && loan.tenorValue <= 84)){
		
								loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.other_customers.interest_rate[i][1] ) );
								loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.other_customers.interest_rate[i][0] ) );
							} 
						} else {
							if (loan.tenorValue == otherCustomersPeriods[i]  && loan.tenorValue <= 36){
								loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.other_customers.interest_rate[i] ) );
							} else if(loan.tenorValue > otherCustomersPeriods[i] && loan.tenorValue < otherCustomersPeriods[i+1] && otherCustomersPeriods[i+1] <= 36){
								loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.other_customers.interest_rate[i+1] ) );
							}
						}
					}

					loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.salary_customers.interest_rate[0] ) );
					
					var customersPeriods = loan.interestRateValue.localCurrency.salary_customers.period;

					for(i = 0; i < customersPeriods.length; i++){
						if(loan.tenorValue > 36){
							if(customersPeriods[i] > 36 && i > 0 && 
									(loan.tenorValue > 36 && customersPeriods[i] == 60 && loan.tenorValue <= 60 
											|| loan.tenorValue > 60 && customersPeriods[i] == 84 && loan.tenorValue <= 84)){
		
								loan.promoInterestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.salary_customers.interest_rate[i][1] ) );
								loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.salary_customers.interest_rate[i][0] ) );
							} 
						} else {
							if (loan.tenorValue == customersPeriods[i] && loan.tenorValue <= 36){
								loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.salary_customers.interest_rate[i] ) );
							} else if(loan.tenorValue > customersPeriods[i] && loan.tenorValue < customersPeriods[i+1] && customersPeriods[i+1] <= 36){
								loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.salary_customers.interest_rate[i+1] ) );
							}

						}
					}
					if(loan.tenorValue <= 36){
						loan.promoInterestRateRemainingPeriod = undefined;
						loan.interestRateRemainingPeriod = undefined;
					}

					//show the second tab
					loan.showHideTab("show");

				}

				//get first period duration standard
				if(( loan.interestRateValue.localCurrency.other_customers.period[0] )!==undefined){

					loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.other_customers.period[0] ) );

				}
				
				//get first period duration standard eur
				if(( loan.interestRateValue.eurCurrency.other_customers.period[0] )!==undefined){

					loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.eurCurrency.other_customers.period[0] ) );

				}

				//get first period duration promo
				if(( loan.interestRateValue.localCurrency.salary_customers.period[0] )!==undefined){

					loan.firstPeriodDurationPromo = Number( parseFloat( loan.interestRateValue.localCurrency.salary_customers.period[0] ) );

				}

				//get the remaining period duration standard
				if(( loan.interestRateValue.localCurrency.other_customers.period[0] )!==undefined){

					loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

				}

				//get the remaining period duration promo
				if(( loan.interestRateValue.localCurrency.salary_customers.period[0] )!==undefined){

					loan.remainingPeriodDurationPromo = loan.tenorValue - loan.firstPeriodDurationPromo;

				}

				console.log("First Period Duration Standard "+loan.firstPeriodDurationStandard);
				console.log("Remaining Period Duration Standard "+loan.remainingPeriodDurationStandard);
				console.log("First Period Duration Promo "+loan.firstPeriodDurationPromo);
				console.log("Remaining Period Duration Promo "+loan.remainingPeriodDurationPromo);

				break;

			case "FAST_LOAN":

				console.log("FAST_LOAN");

				if (loan.selectedCurrencyValue=="eur"){

					loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.other_customers.interest_rate ) );
					loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
					loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.salary_customers.interest_rate ) );
					loan.promoInterestRateRemainingPeriod = loan.promoInterestRateFirstPeriod;

					//show the second tab
                    loan.showHideTab("show");

				}

				if (loan.selectedCurrencyValue=="localCurrency"){

					loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.other_customers.interest_rate ) );
					loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
					loan.promoInterestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.salary_customers.interest_rate ) );
					loan.promoInterestRateRemainingPeriod = loan.promoInterestRateFirstPeriod;

					//show the second tab
					loan.showHideTab("show");

				}

				break;

			case "STUDENT_LOAN":

				console.log("STUDENT_LOAN");

				if (loan.selectedCurrencyValue=="eur"){

					loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[0] ) );

					if(loan.interestRateValue.eur.period[0]>=loan.tenorValue){

						loan.interestRateRemainingPeriod = undefined;

					} else{

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[1] ) );

					}

					loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;
					loan.promoInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

					//get first period duration
					if(( loan.interestRateValue.eur.period[0] )!==undefined){

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.eur.period[0] ) );
						loan.firstPeriodDurationPromo = loan.firstPeriodDurationStandard;

					}

					//get the remaining period duration
					if(( loan.interestRateValue.eur.period[0] )!==undefined){

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;
						loan.remainingPeriodDurationPromo = loan.remainingPeriodDurationStandard

					}

				}

				if (loan.selectedCurrencyValue=="localCurrency"){

					loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[0] ) );
					loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;

					if(loan.interestRateValue.localCurrency.period[0]>=loan.tenorValue){

						loan.interestRateRemainingPeriod = undefined;

					} else{

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[1] ) );

					}

					loan.promoInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

					//get first period duration
					if(( loan.interestRateValue.localCurrency.period[0] )!==undefined){

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[0] ) );
						loan.firstPeriodDurationPromo = loan.firstPeriodDurationStandard;

					}

					//get the remaining period duration
					if(( loan.interestRateValue.localCurrency.period[0] )!==undefined){

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;
						loan.remainingPeriodDurationPromo = loan.remainingPeriodDurationStandard

					}

				}

				//hide the second tab
				loan.showHideTab("hide");

				break;

			case "CAR_LOAN":

				console.log("CAR_LOAN");

				if (loan.selectedCurrencyValue=="eur"){

					if(loan.selectedCarValue=="new"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.new.eur ) );
						loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.variableInterestRate = loan.interestRateFirstPeriod;

					}

					if(loan.selectedCarValue=="used"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.used.eur ) );
						loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.variableInterestRate = loan.interestRateFirstPeriod;

					}

				}

				if (loan.selectedCurrencyValue=="localCurrency"){

					if(loan.selectedCarValue=="new"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.new.localCurrency ) );
						loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.variableInterestRate = loan.interestRateFirstPeriod;

					}

					if(loan.selectedCarValue=="used"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.used.localCurrency ) );
						loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;
						loan.promoInterestRateRemainingPeriod = loan.interestRateFirstPeriod;
						loan.variableInterestRate = loan.interestRateFirstPeriod;

					}

				}

				//hide the second tab
				//loan.showHideTab("hide");

				break;

			case "NON_RESIDENTIAL_SPACE_MORTGAGE":
			case "HOUSE_MORTGAGE":
			case "ALL_PURPOSE_MORTGAGE":

				console.log("MORTGAGE");

				if (loan.selectedCurrencyValue=="eur"){

					if (loan.selectedInterestRateValue=="1yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[0] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[2] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.eur.period[0] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="3yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[1] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[3] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.eur.period[1] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

				}


				if (loan.selectedCurrencyValue=="localCurrency"){

					if (loan.selectedInterestRateValue=="1yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[0] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[3] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[0] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="2yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[1] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[4] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[1] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="3yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[2] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[5] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[2] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

				}

				break;

			case "YOUTH_LOAN":

				console.log("Youth loan");

				if (loan.selectedCurrencyValue=="eur"){

					if (loan.selectedInterestRateValue=="fixed"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[0] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[0] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = loan.tenorValue;

						loan.remainingPeriodDurationStandard = 0;

					}

					if (loan.selectedInterestRateValue=="1yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[1] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[4] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.eur.period[0] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="3yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[2] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[5] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.eur.period[1] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="5yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[3] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.eur.interest_rate[6] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.eur.period[2] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

				}


				if (loan.selectedCurrencyValue=="localCurrency"){

					if (loan.selectedInterestRateValue=="fixed"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[0] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[0] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = loan.tenorValue;

						loan.remainingPeriodDurationStandard = 0;

					}

					if (loan.selectedInterestRateValue=="1yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[1] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[5] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[0] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="2yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[2] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[6] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[1] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="3yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[3] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[7] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[2] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

					if (loan.selectedInterestRateValue=="5yfixed+variable"){

						loan.interestRateFirstPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[4] ) );

						loan.interestRateRemainingPeriod = Number( parseFloat( loan.interestRateValue.localCurrency.interest_rate[8] ) );

						loan.variableInterestRateRemainingPeriod = loan.interestRateRemainingPeriod;

						loan.firstPeriodDurationStandard = Number( parseFloat( loan.interestRateValue.localCurrency.period[3] ) );

						loan.remainingPeriodDurationStandard = loan.tenorValue - loan.firstPeriodDurationStandard;

					}

				}

				break;

			default:

				console.log("unknown category");
				loan.interestRateFirstPeriod = undefined;
				loan.interestRateRemainingPeriod = loan.interestRateFirstPeriod;
				loan.promoInterestRateFirstPeriod = loan.interestRateFirstPeriod;
				loan.promoInterestRateRemainingPeriod = loan.interestRateFirstPeriod;

				break;

		}

		//log
		console.log( "Current Category: " + loan.productCategoryValue + " - " + typeof( loan.productCategoryValue ) );
		console.log( "Selected Currency: " + loan.selectedCurrencyValue + " - " + typeof( loan.selectedCurrencyValue ) );
		console.log( "Selected Interest Rate: " + loan.selectedInterestRateValue + " - " + typeof( loan.selectedInterestRateValue ) );
		console.log( "Interest rate: " + loan.interestRate.val() + " - " + typeof( loan.interestRateValue ) );

		console.log( "Interest rate first period: " + loan.interestRateFirstPeriod + " - " + typeof( loan.interestRateFirstPeriod ) );
		console.log( "Interest rate Remaining period: " + loan.interestRateRemainingPeriod + " - " + typeof( loan.interestRateRemainingPeriod ) );

		console.log( "Promo Interest rate first period: " + loan.promoInterestRateFirstPeriod + " - " + typeof( loan.promoInterestRateFirstPeriod ) );
		console.log( "Promo Interest rate Remaining period: " + loan.promoInterestRateRemainingPeriod + " - " + typeof( loan.promoInterestRateRemainingPeriod ) );

		// standard interest rate
		loan.standardInterestRate = $( '*[data-algoritmInput="standardInterestRate"]', loan.activeCalculator );
		loan.standardInterestRateValue = Number( parseFloat( loan.standardInterestRate.val() ) );


		// max amount for online
		loan.maxAmountForOnline = $( '*[data-algoritmInput="maxAmountForOnline"]' , loan.activeCalculator);
		loan.maxAmountForOnlineValue = Number( parseFloat( loan.maxAmountForOnline.val() ) );

		// log
		console.log( "Max Amount for Online Value: " + loan.maxAmountForOnlineValue + " - " + typeof( loan.maxAmountForOnlineValue ) );

		// borrow
		loan.borrowAmount = $( '*[data-algoritmInput="borrowAmount"]', loan.activeCalculator );
		loan.borrowAmountRoundingValue = Number( parseFloat( loan.borrowAmount.attr( "data-input-rounding" ) ) );
		loan.borrowAmount.val( Number( parseFloat( Math.round( loan.borrowAmount.val().replace( new RegExp( regExSeparator, 'g' ), "" ).replace( new RegExp( regExDecimal, 'g' ), "." ) / loan.borrowAmountRoundingValue ) * loan.borrowAmountRoundingValue ) ) );

		// format currency inputs
		var inputsToFormat = $( '*[data-format-currency]', loan.activeCalculator);

		if( inputsToFormat.length ) {

			inputsToFormat.each( function() {

				var currencyName = $( this ).attr( 'data-currency-name' );
				var	currencyInputSelector = '[data-currency-name="' + currencyName +'"]';

				var cleave = new Cleave( currencyInputSelector, {

					delimiter: genericSettings.separator,
					numeral: true,
					numeralDecimalMark: genericSettings.decimal,
					numeralDecimalScale: 0,
					numeralThousandsGroupStyle: 'thousand'

				} );

			} );

		}

		loan.borrowAmountValue = Number( parseFloat( loan.borrowAmount.val().replace( new RegExp( regExSeparator, 'g' ), "" ).replace( new RegExp( regExDecimal, 'g' ), "." ) ) );
		loan.borrowAmountMin = Number( parseFloat( loan.borrowAmount.attr( "data-input-min" ) ) );
		loan.borrowAmountMax = Number( parseFloat( loan.borrowAmount.attr( "data-input-max" ) ) );
		// loan.borrowAmountStep = Number( parseFloat( loan.borrowAmount.data( "sliderStep" ) ) );



		// log
		console.log( "Borrow Amount Rounding: " + loan.borrowAmountRoundingValue + " - " + typeof( loan.borrowAmountRoundingValue ) );
		console.log( "Borrow Amount Value: " + loan.borrowAmountValue + " - " + typeof( loan.borrowAmountValue ) );
		console.log( "Borrow Amount Min Value: " + loan.borrowAmountMin + " - " + typeof( loan.borrowAmountMin ) );
		console.log( "Borrow Amount Max Value: " + loan.borrowAmountMax + " - " + typeof( loan.borrowAmountMax ) );
		// console.log( "Borrow Amount Step Value: " + loan.borrowAmountStep + " - " + typeof( loan.borrowAmountStep ) );

	};

	/* --------------------- */

	/**
	 * Fill output elements
	 *
	 */
	this.fillOutputElements = function() {

		loan.fillOutputElementsPromo();
		loan.fillOutputElementsStandard();

	};

	/**
	 * Fill output elements Promo
	 *
	 */
	this.fillOutputElementsPromo = function() {

		if( validPromoResults ) {

			loan.interestRatePromo.text( loan.interestRateResultPromo );

			loan.loanAmountPromo.text( loan.loanAmountResultPromo );
			loan.tenorPromo.text( loan.tenorResultPromo );
			loan.monthlyInstallmentPromoFirstPeriod.text( loan.monthlyInstallmentResultPromo );
			loan.monthlyInstallmentPromoRemainingPeriod.text( loan.monthlyInstallmentResultPromo2 );

			loan.fixedInterestRatePromoFirstPeriod.text( loan.promoInterestRateFirstPeriod );
			loan.fixedInterestRatePromoRemainingPeriod.text( loan.promoInterestRateRemainingPeriod );

			loan.amountToRepayPromo.text( loan.amountToRepayResultPromo );

			// update basket cookie
		//	loan.updateBasketCookie(); - not needed at this point

			// check max borrow amount
			if( loan.loanAmountCalculatedPromo > loan.maxAmountForOnlineValue ) {

				//loan.toggleShopBtn( loan.getButton, "hide" );- not needed at this point
				loan.callButton.show();

			} else {

				//loan.toggleShopBtn( loan.getButton, "show" );- not needed at this point
				loan.callButton.hide();

			}

		} else loan.resetOutputElementsPromo();

	};

	/**
	 * Fill output elements Standard
	 *
	 */
	this.fillOutputElementsStandard = function() {

		// show results
		if( validStandardResults ) {

			loan.interestRateStandard.text( loan.interestRateResultStandard );

			loan.fixedInterestRateStandardFirstPeriod.text( loan.interestRateFirstPeriod );
			loan.fixedInterestRateStandardRemainingPeriod.text( loan.interestRateRemainingPeriod );

			loan.loanAmountStandard.text( loan.loanAmountResultStandard );
			loan.tenorStandard.text( loan.tenorResultStandard );
			loan.monthlyInstallmentStandardFirstPeriod.text( loan.monthlyInstallmentResultStandard );
			loan.monthlyInstallmentStandardRemainingPeriod.text( loan.monthlyInstallmentResultStandard2 );
			loan.amountToRepayStandard.text( loan.amountToRepayResultStandard );

			loan.variableInterestRateStandard.text( loan.variableInterestRate );
			loan.variableInterestRateStandardRemainingPeriod.text( loan.variableInterestRateRemainingPeriod );

		} else loan.resetOutputElementsStandard();

	};

	/* --------------------- */

	/**
	 * Update basket cookie
	 *
	 */
	this.updateBasketCookie = function() {

		var basketButtons = $( "*[data-generate-cookie]" );
		var cmbInput = $( "*[data-cmb-input]" );

		if( basketButtons.length ) {

			var loanConfigurationBasket = basketButtons.attr( "data-c-personalLoanConfiguration" );

		} else {

			var loanConfigurationBasket = '{"LOANAMOUNT": "-","DURATION": "0","INSTALLMENT": "-","DISCOUNTCODE": "-","APR": "0","INTERESTRATE": "0"}';

		}

		// update json object
		var loanConfigurationBasketJSON = JSON.parse( loanConfigurationBasket );
		loanConfigurationBasketJSON.DURATION = loan.tenorCalculatedPromo.toString();
		loanConfigurationBasketJSON.INSTALLMENT = loan.monthlyInstallmentValuePromo.toString();
		loanConfigurationBasketJSON.INTERESTRATE = loan.promoInterestRateFirstPeriod.toString();
		loanConfigurationBasketJSON.LOANAMOUNT = loan.loanAmountCalculatedPromo.toString();

		if( basketButtons.length ) {

			// update button cookie
			basketButtons.attr( "data-c-personalLoanConfiguration", JSON.stringify( loanConfigurationBasketJSON ) );

		}

		if( cmbInput.length ) {

			// update the input of call me back
			cmbInput.val( JSON.stringify( loanConfigurationBasketJSON ) );

		}

	};

	/**
	 * Toogle shop btn
	 *
	 */
	this.toggleShopBtn = function( btns, action ) {

		btns.each( function( index, element ) {

			var btn = $( element );

			if( btn.hasClass( "sectionNewAccount" ) || btn.hasClass( "sectionNewAccount_hide" ) ) {

				var loginBtn = btn.parent().find( ".sectionLogin" );

				if( action == "hide" ) {

					btn.css( {

						opacity: 0,
						top: "-3000px"

					} );
					btn.removeClass( "sectionNewAccount" ).addClass( "sectionNewAccount_hide" );

					if( loginBtn.length ) {

						loginBtn.css( {

							opacity: 1,
							top: "50%"

						} );

					}

				} else {

					btn.css( {

						opacity: 1,
						top: "50%"

					} );
					btn.removeClass( "sectionNewAccount_hide" ).addClass( "sectionNewAccount" );

					if( loginBtn.length ) {

						loginBtn.css( {

							opacity: 0,
							top: "-3000px"

						} );

					}

				}

			} else {

				if( action == "hide" ) btn.hide();
				else btn.show();

			}

		} );

	};

};

/**
 * Get class instance
 *
 */
Intesa.LoanCalculatorAlbania.getInstance = function() {

	if( !window.intesa ) {

		window.intesa = new Object();

	}
	if( !window.intesa.loan_calculator_albania ) {

		window.intesa.loan_calculator_albania = new Intesa.LoanCalculatorAlbania();

	}

	return window.intesa.loan_calculator_albania;

};

/**
 * On DOM ready
 *
 */
// $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {

	// wait Bitmama slider script
	setTimeout( function() {

		// init calculator
		var loan = Intesa.LoanCalculator.getInstance();
		loan.init();

	}, 1000 );

} ); */
